/* eslint-disable react/prop-types */
/* eslint-disable react/destructuring-assignment */
import React, {Component} from 'react';

import {connect} from 'react-redux';

import * as loadingActions from '@/actions/loadingActions';
import * as setupActions from '@/actions/setupActions';
import {Post, GetRequest} from '@/api/request';
import Loading from '@/assets/icons/Loading.gif';
import closeFolderIcon from '@/assets/icons/usb/closeFolder.svg';
import noFolderListIcon from '@/assets/icons/usb/noFolderList.svg';
import openFolderIcon from '@/assets/icons/usb/openFolder.svg';
import ListExplorer from '@/components/explorer/explorerView/listExplorer/ListExplorer';
import ToggleButton from '@/components/togglebutton/ToggleButton';
import Tree from '@/components/tree/Tree';
import {ALERT_TYPE} from '@/constants/enums';
import {EXPORT_IMPORT} from '@/constants/messages';
import * as APPDATA from '@/constants/pcConstAppData';
import {IsEmpty} from '@/libs/appHelper';
import {consoleLog} from '@/libs/consoleHelper';

import './UsbFolderList.less';

@connect((store) => ({
  fontSize: store.setupStore.fontSize,
  selectedDateBegin: store.setupStore.selectedDateBeginExport,
  selectedDateEnd: store.setupStore.selectedDateEndExport,
  usbProperties: store.setupStore.usbProperties,
  usbOpenFor: store.setupStore.usbOpenFor,
}))
class USBFolderListSystemLog extends Component {
  constructor(props) {
    super(props);
    this.state = {
      folderList: [],
      dataState: -1,
      currentDrive: 0,
      selectedFolder: {},
    };
    this.errorSaveFile = this.errorSaveFile.bind(this);
    this.failedSaveFile = this.failedSaveFile.bind(this);
  }

  // --------------------------- End Component Will Receive Props ------------
  componentDidMount() {
    this._ismounted = true;

    consoleLog('USB folder list componentDidMount ', this.props);
    consoleLog('selectedDateBegin, ', this.props.selectedDateBegin);
    consoleLog('selectedDateEnd, ', this.props.selectedDateEnd);
    this.props.dispatch(setupActions.updateActiveMenu(APPDATA.SELECT_FOLDER_SYSTEM_LOG));

    this.getFolderList(this.props.usbProperties[0].Path);
    // var label = this.props.usbProperties === undefined ? "" : this.props.usbProperties.Label;
    this.setState({dataState: ListExplorer.state.WAITING_DATA});
    this.setTopMenuProperties(false, APPDATA.SELECT_FOLDER_SYSTEM_LOG);
  }

  // ------------------------------ Coponent Will Receive Props ---------------
  UNSAFE_componentWillReceiveProps(nextProps) {
    consoleLog('componentWillReceiveProps', nextProps);
  }

  componentWillUnmount() {
    this._ismounted = false;
    // this.props.dispatch(setupActions.selectedFolderExportDestination(undefined));
    this.props.dispatch(setupActions.usbProperties(undefined));
    this.props.dispatch(setupActions.selectedDateBeginExport(''));
    this.props.dispatch(setupActions.selectedDateEndExport(''));
  }

  setTopMenuProperties = (disabledMainButton, titleMenu) => {
    const topButtonProperties = {
      id: APPDATA.EXPORT,
      label: APPDATA.EXPORT,
      onClick: this.onClickTopMenu,
      disabled: disabledMainButton,
    };
    const backButtonProperties = {
      id: APPDATA.BACK,
      label: '',
      disabled: false,
      onClick: this.onClickTopMenu,
    };
    const titleMenuProperties = titleMenu;

    this.props.dispatch(
      setupActions.setTopMenuProperties({
        topButtonProperties:
          topButtonProperties === undefined
            ? undefined
            : {
                id: topButtonProperties.id,
                label: topButtonProperties.label,
                disabled: topButtonProperties.disabled,
                onClick: topButtonProperties.onClick,
              },
        backButtonProperties:
          backButtonProperties === undefined
            ? undefined
            : {
                id: backButtonProperties.id,
                label: backButtonProperties.label,
                disabled: backButtonProperties.disabled,
                onClick: backButtonProperties.onClick,
              },
        titleMenuProperties,
      }),
    );
    this.props.dispatch(setupActions.topButtonTertiaryProperties(undefined));
  };

  onClickTopMenu = (e) => {
    const {selectedFolder, currentDrive} = this.state;
    const {usbProperties, selectedDateBegin, selectedDateEnd} = this.props;
    switch (e.currentTarget.id) {
      case APPDATA.EXPORT: {
        consoleLog('onClick Export', {selectedFolder, usbProperties, currentDrive});
        let destinationPath;
        if (selectedFolder.Path !== undefined) {
          destinationPath = selectedFolder.Path;
          consoleLog('save to folder', destinationPath);
        } else {
          destinationPath = usbProperties[currentDrive].Path;
          consoleLog('save to root', destinationPath);
        }
        this.exportFileLog(selectedDateBegin, selectedDateEnd, destinationPath);
        break;
      }
      case APPDATA.BACK:
        this.goToLogMenuPage();
        break;
      default:
        break;
    }
  };

  // eslint-disable-next-line class-methods-use-this
  generateBottomMenu = () => <div className="usbFolderListBottom center footer" />;

  // eslint-disable-next-line class-methods-use-this
  goToLogMenuPage = () => {
    window.location.href = APPDATA.SYSTEM_LOGS_ADDRESS;
  };

  // ------------------------- Get Folder List ------------------------------
  folderTreeChild = ({folder, keyParent}) => {
    const directories = [];
    // consoleLog("folderTreeChild", folder);
    for (let id = 0; id < folder.length; id++) {
      let directory = {};
      let key;
      if (keyParent === undefined) {
        key = id;
      } else {
        key = `${keyParent}-${id}`;
      }

      let content = [];
      if (folder[id].Content.length > 0)
        content = this.folderTreeChild({folder: folder[id].Content, keyParent: key.toString()});
      directory = {
        key: key.toString(),
        Path: folder[id].Path,
        label: folder[id].Label,
        icon: closeFolderIcon,
        hasChildIcon: openFolderIcon,
        children: content,
        childVisible: false,
        isActive: false,
      };
      directories.push(directory);
    }
    return directories;
  };

  // eslint-disable-next-line react/sort-comp
  successGetFolderList(response) {
    const {details, message} = response.data;

    if (!IsEmpty(message)) {
      this.failedsGetFolderList();
      return;
    }

    const folderList = this.folderTreeChild({folder: details});
    if (this._ismounted) {
      this.setState({
        folderList,
        dataState: ListExplorer.state.AVAILABLE_DATA,
      });
    }
  }

  failedsGetFolderList = () => {
    if (this._ismounted) {
      this.setState({dataState: ListExplorer.state.NO_DATA});
      this.props.dispatch(
        setupActions.showAlert({
          alertShow: true,
          alertText: EXPORT_IMPORT.FLASH_DRIVE_NOT_FOUND,
          alertStyle: ALERT_TYPE.ALERT_DANGER,
        }),
      );
      window.location.href = APPDATA.SYSTEM_LOGS_ADDRESS;
    }
  };

  getFolderList = (path) => {
    if (this.props.usbProperties !== undefined) {
      switch (this.props.usbOpenFor) {
        case APPDATA.USB_OPEN_FOR.EXPORT_SYSTEM_LOGS: {
          const params = {
            params: {
              path,
              level: -1,
            },
          };
          GetRequest(APPDATA.API.GET_FOLDER_STRUCTURE, params).then((response) => this.successGetFolderList(response));

          break;
        }
        default:
          break;
      }
    } else {
      consoleLog('usb undefined');
    }
  };
  // --------------------- End Get Folder List ------------------------------

  // --------------------- send path folder ---------------------------------
  exportFileLog = (beginDate, endDate, destination) => {
    this.props.dispatch(
      loadingActions.updateLoading({
        showLoading: true,
        loadingText: APPDATA.MESSAGES.SYSTEM_LOG.EXPORTING_SYSTEM_LOG,
        loadingClickEvent: undefined,
        loadingButton1: undefined,
      }),
    );

    const params = {
      beginDate,
      endDate,
      path: destination,
    };
    consoleLog('exportFileLog to destination folder', params);

    const url = APPDATA.API.POST_SAVE_SYSTEM_LOG;
    Post(url, params, this.successSaveFile, params, this.errorSaveFile, this.failedSaveFile);
  };

  successSaveFile = (response) => {
    consoleLog('successSaveFiles', {response});
    this.props.dispatch(loadingActions.showLoading(false));
    this.props.dispatch(
      setupActions.showAlert({
        alertShow: true,
        alertText: APPDATA.MESSAGES.SYSTEM_LOG.SUCCESS_EXPORT,
        alertStyle: APPDATA.ENUM.ALERT_TYPE.ALERT_SUCCESS,
      }),
    );
    this.goToLogMenuPage();
  };

  failedSaveFile = (response, passingVariabel) => {
    consoleLog('failedSaveFile', {response, passingVariabel});
    this.props.dispatch(loadingActions.showLoading(false));
    let message = APPDATA.MESSAGES.SYSTEM_LOG.ERROR_EXPORT;
    if (response.data.message === 'Failed Save Log' && response.data.details.includes('DiskFull')) {
      message = APPDATA.MESSAGES.SYSTEM_LOG.ERROR_EXPORT_STORAGE_FULL;
    } else if (response.data.message === 'Failed Save Log' && response.data.details.includes('PathNotFound')) {
      message = APPDATA.MESSAGES.EXPORT_IMPORT.FLASH_DRIVE_NOT_FOUND;
    }
    this.props.dispatch(
      setupActions.showAlert({
        alertShow: true,
        alertText: message,
        alertStyle: APPDATA.ENUM.ALERT_TYPE.ALERT_DANGER,
      }),
    );
    this.goToCycleHistory();
  };

  errorSaveFile = (error, passingVariabel) => {
    consoleLog('errorSaveFile', {error: error.response, passingVariabel});
    this.props.dispatch(loadingActions.showLoading(false));
    let message = APPDATA.MESSAGES.SYSTEM_LOG.ERROR_EXPORT;
    if (error.response.data.message === 'Failed Save Log' && error.response.data.details.includes('DiskFull')) {
      message = APPDATA.MESSAGES.SYSTEM_LOG.ERROR_EXPORT_STORAGE_FULL;
    } else if (
      error.response.data.message === 'Failed Save Log' &&
      error.response.data.details.includes('PathNotFound')
    ) {
      message = APPDATA.MESSAGES.EXPORT_IMPORT.FLASH_DRIVE_NOT_FOUND;
    }
    this.props.dispatch(
      setupActions.showAlert({
        alertShow: true,
        alertText: message,
        alertStyle: APPDATA.ENUM.ALERT_TYPE.ALERT_DANGER,
      }),
    );
    this.goToCycleHistory();
    // failed send path
  };

  //---------------------------------------------------------------------------------------
  updateFolderTree = ({folder, selectedKey}) => {
    const directories = [];
    // consoleLog("updateFolderTree", folder);
    for (let id = 0; id < folder.length; id++) {
      let directory = {};
      let content = [];
      const isChildVisible = folder[id].key === selectedKey ? !folder[id].childVisible : folder[id].childVisible;
      const activeFolder = folder[id].key === selectedKey;
      if (folder[id].children.length > 0) content = this.updateFolderTree({folder: folder[id].children, selectedKey});
      directory = {
        ...folder[id],
        children: content,
        childVisible: isChildVisible,
        isActive: activeFolder,
      };
      directories.push(directory);
    }
    return directories;
  };

  onClickFolder = (folder) => {
    const {folderList, selectedFolder} = this.state;
    consoleLog('onclick folder', folder);
    let tempTree = [];
    let selectFolder = {
      Path: folder.Path,
      key: folder.key,
      label: folder.label,
    };
    if (folder.key === selectedFolder.key) {
      tempTree = this.updateFolderTree({folder: folderList, selectedKey: '-1'});
      selectFolder = {};
    } else {
      tempTree = this.updateFolderTree({folder: folderList, selectedKey: folder.key});
    }

    this.setState(
      {
        folderList: tempTree,
        selectedFolder: selectFolder,
      },
      () => {
        // consoleLog("onClickFolder", this.state);
        // if (this.state.selectedFolder !== {}) this.setTopMenuProperties(false, APPDATA.SELECT_FOLDER);
      },
    );
  };

  onClickChangeUSB = (e) => {
    this.setState(
      {
        currentDrive: e.currentTarget.id,
        dataState: ListExplorer.state.WAITING_DATA,
        selectedFolder: {},
      },
      () => {
        const params = {
          params: {
            path: this.props.usbProperties[this.state.currentDrive].Path,
            level: -1,
          },
        };
        GetRequest(APPDATA.API.GET_FOLDER_STRUCTURE, params).then((response) => this.successGetFolderList(response));
      },
    );
  };

  renderView = () => {
    // handle not set  data state. because default data state is ListExplorer.state.AVAILABLE_DATA
    const {dataState, folderList} = this.state;
    let tempDataState = dataState;
    if (tempDataState === ListExplorer.state.AVAILABLE_DATA) {
      if (folderList === undefined) tempDataState = -1;
      else if (folderList.length === 0) tempDataState = ListExplorer.state.NO_DATA;
    }

    switch (tempDataState) {
      case ListExplorer.state.WAITING_DATA:
        return (
          <div className="folderLoading">
            <img
              className="loadingIcon"
              src={Loading}
              alt={Loading}
              width={125}
              height={125}
            />
            <br />
            <span>Please Wait!</span>
          </div>
        );
      case ListExplorer.state.NO_DATA:
        return (
          <div className="notFoundFolderList">
            <img
              src={noFolderListIcon}
              alt={noFolderListIcon}
              className="wifiDisableIcon"
            />
            <div className="text">
              <div>{APPDATA.MESSAGES.SYSTEM_LOG.NO_FOLDER_FOUND}</div>
              <div>{APPDATA.MESSAGES.SYSTEM_LOG.STORE_LOGS_HERE}</div>
            </div>
          </div>
        );
      case ListExplorer.state.AVAILABLE_DATA:
        return (
          <div className="folderTreeList">
            <Tree
              data={folderList}
              callbackOnClick={this.onClickFolder}
            />
          </div>
        );
      default:
        return null;
    }
  };

  render() {
    const style = {
      constraint: {
        fontSize: this.props.fontSize,
      },
    };
    const {usbProperties} = this.props;
    const {currentDrive} = this.state;
    const usbDriveButtonProp = [];
    let divUsbDriveBottonClassName = 'col-md-12';
    if (usbProperties !== undefined) {
      for (let id = 0; id < usbProperties.length; id++) {
        const tempUsbDriveButtonProp = {
          label: usbProperties[id].Label,
          value: id,
          id,
          onClick: this.onClickChangeUSB,
        };
        usbDriveButtonProp[id] = tempUsbDriveButtonProp;
      }

      let colMdSize = 12;
      const tmpLen = usbProperties.length;
      if (tmpLen < 5 && tmpLen > 0) {
        colMdSize = tmpLen * 3;
      }
      divUsbDriveBottonClassName = `col-md-${colMdSize}`;
    }
    return (
      <div
        style={style.constraint}
        className="usbFolderPage"
      >
        <div className="rowHeightToggleButton middleAlign ">
          <div className={`${divUsbDriveBottonClassName} toggleProfileType`}>
            <ToggleButton
              buttonProp={usbDriveButtonProp}
              defaultValue={currentDrive}
              value={currentDrive}
              onClick={this.onClickChangeUSB}
            />
          </div>
        </div>
        {this.renderView()}
        {this.generateBottomMenu()}
      </div>
    );
  }
}
export default USBFolderListSystemLog;
